
import { ArrowLeft } from "lucide-react";
import InvitationSteps from "./InvitationSteps";

interface InvitationHeaderProps {
  onBack: () => void;
}

const InvitationHeader = ({ onBack }: InvitationHeaderProps) => {
  return (
    <div className="mb-8">
      <button
        onClick={onBack}
        className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeft className="h-4 w-4 mr-1" />
        <span>Retour à l'équipe</span>
      </button>

      <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
        Inviter des membres
      </h1>
      <p className="text-sm text-gray-600 dark:text-gray-400">
        Invitez de nouveaux membres à rejoindre votre organisation
      </p>

      <InvitationSteps />
    </div>
  );
};

export default InvitationHeader;
